<template>
  <v-row justify="end">
    <v-col cols="auto" class="align-self-center">
      <v-chip
        v-if="userIsImpersoniated()"
        color="info"
        v-text="getImpersonationText()"
      />
      <v-menu offset-y left>
        <template v-slot:activator="{ on }">
          <v-btn tile icon v-on="on">
            <v-icon size="16">
              mdi-cog
            </v-icon>
          </v-btn>
        </template>
        <v-list>
          <a-metalink-dev-info-item />
          <v-list-item to="/menu/sitemap" link>
            <v-list-item-title v-t="'Components.MetalinkNavigation.Sidemap'" />
          </v-list-item>
          <v-list-item to="/main/productinfo" link>
            <v-list-item-title
              v-t="'Components.MetalinkNavigation.SystemInformation'"
            />
          </v-list-item>
        </v-list>
      </v-menu>
      <a-user-image-menu />
    </v-col>
  </v-row>
</template>

<script>
import { getUserFullName } from "@/config/keycloak/keycloakUser";
import MetaLinkDevInfoButton from "+/components/navigation/metalinkNavigation/MetaLinkDevInfoButton";
import UserImageMenu from "+/components/navigation/metalinkNavigation/UserImageMenu";
import {
  getUserName,
  isUserImpersoniated
} from "@/config/keycloak/keycloakUser";

export default {
  components: {
    "a-metalink-dev-info-item": MetaLinkDevInfoButton,
    "a-user-image-menu": UserImageMenu
  },
  methods: {
    userIsImpersoniated() {
      return isUserImpersoniated();
    },
    getUserNameFromToken() {
      return getUserName();
    },
    getImpersonationText() {
      return this.$t("Components.MetalinkNavigation.LoggedInAs", [
        this.getUserNameFromToken()
      ]);
    },
    getUserFullName() {
      return getUserFullName();
    }
  }
};
</script>
